import Vue from 'vue';

export default () => Vue.$http.get('Orders/count');



// WEBPACK FOOTER //
// ./src/services/order/countAll.js